import * as React from 'react';

const Cz24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#C40028", d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 12h18V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#29457C",
    d: "M3.668 6.508C3.258 6.875 3 7.408 3 8v8c0 .593.258 1.125.668 1.492L10.88 12z"
  }
));
Cz24.Size = 24;
Cz24.Title = "Cz";

export { Cz24 as default };
